// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { object } from 'prop-types'

const FormatModel = ({ rowData: { modelNumber, company } }) => (
  <div className={'text-ellipsis'} title={`Model: ${modelNumber}`}>{modelNumber}</div>
)

FormatModel.propTypes = {
  rowData: object.isRequired,
}

export default FormatModel
